import React from 'react';
import burgerLogo from './burger-logo.png';
import classes from './Logo.css';

const logo = () => (
	<div className={classes.Logo}>
		<img src='./burger-logo.png' alt ='MyBurger'/>
	</div>
);

export default logo;


// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js